import { LiveIndex } from "@/components/hero/LiveIndex";
import { BHeroCopy, B_GRID_BG } from "@/components/hero/BHeroCopy";
import { useHeroLiveStats } from "@/lib/useHeroLiveStats";

export const HeroOptionB = () => {
  const live = useHeroLiveStats();
  return (
    <section data-testid="hero-option-b" className="relative overflow-hidden border-b hairline bg-white">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none opacity-[0.5]" style={B_GRID_BG} />
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(900px 600px at 85% 0%, rgba(15,17,23,0.07), transparent 60%)" }} />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-12 sm:py-16 lg:py-20 grid grid-cols-1 lg:grid-cols-12 gap-x-12 gap-y-12 items-center">
        <BHeroCopy prefix="hero-option-b" className="lg:col-span-7" />
        <LiveIndex live={live} className="lg:col-span-5" />
      </div>
    </section>
  );
};
